import StaffWeeklyRewards from './StaffWeeklyRewards';

const StaffOverallRewards = () => (
  <StaffWeeklyRewards
    activeSection="overall-rewards"
    pageTitle="Season Rewards"
    pageSubtitle="Configure leaderboard rewards for a custom points period."
    loadingLabel="Loading season rewards..."
    emptyActiveLabel="No active season rewards."
    emptyAllLabel="No season rewards created yet."
    emptyCompletedLabel="No completed season rewards yet."
    deleteConfirmLabel="Delete this season reward?"
    loadErrorLabel="Failed to load season rewards."
    deleteErrorLabel="Failed to delete season reward."
    saveErrorLabel="Failed to save season reward."
    formCreateTitle="Add Season Reward"
    formEditTitle="Update Season Reward"
    formCreateSubtitle="Create a season reward for custom leaderboard winners."
    formEditSubtitle="Update season reward settings."
    termsPlaceholder="Season reward terms shown in app"
    defaultCoverTitle="Season reward"
    defaultDescription="Top points earner in your school wins this season."
    coverTitlePlaceholder="Season reward"
    startDateLabel="Start Date"
    endDateLabel="End Date"
    startEndRequiredError="Set both start and end dates."
    endBeforeStartError="End date cannot be earlier than start date."
    overlapError="Date range overlaps with an existing season reward."
    dateStartKey="start_date"
    dateEndKey="end_date"
    dateStartAtKey="start_at"
    dateEndAtKey="end_at"
    dateStartTimeKey="start_time"
    dateEndTimeKey="end_time"
    defaultStartTime="00:00"
    defaultEndTime="16:00"
    startTimeLabel="Start time"
    endTimeLabel="End time"
    autoFillNextRange={false}
    usesCombinedDateTime={false}
    apiMethods={{
      get: 'getOverallPrizes',
      create: 'createOverallPrize',
      update: 'updateOverallPrize',
      delete: 'deleteOverallPrize',
    }}
  />
);

export default StaffOverallRewards;
